module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./PunchClockView.js"));
	}, "PunchClockView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PunchClockView!./src/pages/PunchClock/PunchClockView.js
// module id = 1251
// module chunks = 438